import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=bf0fd8ca&scoped=true"
import script from "./Vip.vue?vue&type=script&lang=js"
export * from "./Vip.vue?vue&type=script&lang=js"
import style0 from "./Vip.vue?vue&type=style&index=0&id=bf0fd8ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0fd8ca",
  null
  
)

export default component.exports